window.theme = window.theme || {};

/* ================ SLATE ================ */
window.theme = window.theme || {};

theme.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  $(document)
    .on('shopify:section:load', this._onSectionLoad.bind(this))
    .on('shopify:section:unload', this._onSectionUnload.bind(this))
    .on('shopify:section:select', this._onSelect.bind(this))
    .on('shopify:section:deselect', this._onDeselect.bind(this))
    .on('shopify:block:select', this._onBlockSelect.bind(this))
    .on('shopify:block:deselect', this._onBlockDeselect.bind(this));

    // Global sections event listeners
    // Section select
    $(document).on('shopify:section:select', function(evt){
      if (evt.detail.sectionId !== "sidebar-menu") {
        theme.LeftDrawer.close();
      }
    });
};


theme.Sections.prototype = _.assignIn({}, theme.Sections.prototype, {
  _createInstance: function(container, constructor) {
    var $container = $(container);
    var id = $container.attr('data-section-id');
    var type = $container.attr('data-section-type');

    constructor = constructor || this.constructors[type];

    if (_.isUndefined(constructor)) {
      return;
    }

    var instance = _.assignIn(new constructor(container), {
      id: id,
      type: type,
      container: container
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function(evt) {
    var container = $('[data-section-id]', evt.target)[0];
    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function(evt) {
    this.instances = _.filter(this.instances, function(instance) {
      var isEventInstance = (instance.id === evt.detail.sectionId);

      if (isEventInstance) {
        if (_.isFunction(instance.onUnload)) {
          instance.onUnload(evt);
        }
      }

      return !isEventInstance;
    });
  },

  _onSelect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onSelect)) {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onDeselect)) {
      instance.onDeselect(evt);
    }
  },

  _onBlockSelect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onBlockSelect)) {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onBlockDeselect)) {
      instance.onBlockDeselect(evt);
    }
  },

  register: function(type, constructor) {
    this.constructors[type] = constructor;

    $('[data-section-type=' + type + ']').each(function(index, container) {
      this._createInstance(container, constructor);
    }.bind(this));
  }
});


/* ================ MODULES ================ */
window.a11y = window.a11y || {};

a11y.trapFocus = function ($container, eventNamespace) {
  var eventName = eventNamespace ? 'focusin.' + eventNamespace : 'focusin';

  $container.attr('tabindex', '-1').focus();

  $(document).on(eventName, function (evt) {
    if ($container[0] !== evt.target && !$container.has(evt.target).length) {
      $container.focus();
    }
  });
};

a11y.removeTrapFocus = function ($container, eventNamespace) {
  var eventName = eventNamespace ? 'focusin.' + eventNamespace : 'focusin';

  $container.removeAttr('tabindex');
  $(document).off(eventName);
};

window.Modals = (function () {
  var Modal = function (id, name, options) {
    var defaults = {
      close: '.js-modal-close',
      open: '.js-modal-open-' + name,
      openClass: 'modal--is-active'
    };

    this.$modal = $('#' + id);

    if (!this.$modal.length) {
      return false;
    }

    this.$nodes = {
      parent: $('body, html')
    };
    this.config = $.extend(defaults, options);
    this.modalIsOpen = false;
    this.focusOnOpen = this.config.focusOnOpen ? $(this.config.focusOnOpen) : this.$modal;
    this.init();
  };

  Modal.prototype.init = function () {
    var $openBtn = $(this.config.open);

    // Add aria controls
    $openBtn.attr('aria-expanded', 'false');

    $(this.config.open).on('click', $.proxy(this.open, this));
    this.$modal.find(this.config.close).on('click', $.proxy(this.close, this));
  };

  Modal.prototype.open = function (evt) {
    // Keep track if modal was opened from a click, or called by another function
    var externalCall = false;

    // don't open an opened modal
    if (this.modalIsOpen) {
      return;
    }

    // Prevent following href if link is clicked
    if (evt) {
      evt.preventDefault();
    } else {
      externalCall = true;
    }

    // Without this, the modal opens, the click event bubbles up to $nodes.page
    // which closes the modal.
    if (evt && evt.stopPropagation) {
      evt.stopPropagation();
      // save the source of the click, we'll focus to this on close
      this.$activeSource = $(evt.currentTarget);
    }

    if (this.modalIsOpen && !externalCall) {
      return this.close();
    }

    this.$modal.prepareTransition().addClass(this.config.openClass);
    this.$nodes.parent.addClass(this.config.openClass);

    this.modalIsOpen = true;

    // Set focus on modal
    a11y.trapFocus(this.focusOnOpen, 'modal_focus');

    if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
      this.$activeSource.attr('aria-expanded', 'true');
    }

    this.bindEvents();
  };

  Modal.prototype.close = function () {
    // don't close a closed modal
    if (!this.modalIsOpen) {
      return;
    }

    // deselect any focused form elements
    $(document.activeElement).trigger('blur');

    this.$modal.prepareTransition().removeClass(this.config.openClass);
    this.$nodes.parent.removeClass(this.config.openClass);

    this.modalIsOpen = false;

    // Remove focus on modal
    a11y.removeTrapFocus(this.focusOnOpen, 'modal_focus');

    if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
      this.$activeSource.attr('aria-expanded', 'false');
    }

    this.unbindEvents();
  };

  Modal.prototype.bindEvents = function() {
    // Pressing escape closes modal
    this.$nodes.parent.on('keyup.modal', $.proxy(function(evt) {
      if (evt.keyCode === 27) {
        this.close();
      }
    }, this));
  };

  Modal.prototype.unbindEvents = function() {
    this.$nodes.parent.off('.modal');
  };

  return Modal;
})();

/**
 *  Vendor
 *
 *  Small minified vendor scripts can be placed at the top of this file to
 *  reduce network requests.
 *
 */

/**
 *
 *  ShopifyCanvas JS
 *  - Base Canvas functions and utilities.
 *
 */
window.ShopifyCanvas = window.ShopifyCanvas || {};

/**
 *
 *  Initialize function for all ShopifyCanvas JS.
 *  - call any functions required on page load here.
 *
 */
ShopifyCanvas.init = function () {
  ShopifyCanvas.cacheSelectors();
  ShopifyCanvas.checkUrlHash();
  ShopifyCanvas.initEventListeners();
  ShopifyCanvas.resetPasswordSuccess();
  ShopifyCanvas.customerAddressForm();
};

/**
 *
 *  Cache any jQuery objects.
 *
 */
ShopifyCanvas.cacheSelectors = function () {
  ShopifyCanvas.cache = {
    $html : $('html'),
    $body : $('body')
  }
};

ShopifyCanvas.initEventListeners = function () {
  //Show reset password form
  $('#RecoverPassword').on('click', function(evt) {
    evt.preventDefault();
    ShopifyCanvas.toggleRecoverPasswordForm();
  });

  //Hide reset password form
  $('#HideRecoverPasswordLink').on('click', function(evt) {
    evt.preventDefault();
    ShopifyCanvas.toggleRecoverPasswordForm();
  });
};

/**
 *
 *  Show/Hide recover password form
 *
 */
ShopifyCanvas.toggleRecoverPasswordForm = function () {
  $('#RecoverPasswordForm').toggleClass('hide');
  $('#CustomerLoginForm').toggleClass('hide');
};

/**
 *  Show reset password success message
 */
ShopifyCanvas.resetPasswordSuccess = function() {
  var $formState = $('.reset-password-success');

  //check if reset password form was successfully submited.
  if (!$formState.length) {
    return;
  }

  // show success message
  $('#ResetSuccess').removeClass('hide');
};

/**
 *  Show/hide customer address forms
 */
ShopifyCanvas.customerAddressForm = function () {
  var $newAddressForm = $('#AddressNewForm');

  if (!$newAddressForm.length) {
    return;
  }

  // Initialize observers on address selectors, defined in shopify_common.js
  new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
    hideElement: 'AddressProvinceContainerNew'
  });

  // Initialize each edit form's country/province selector
  $('.address-country-option').each(function() {
    var formId = $(this).data('form-id');
    var countrySelector = 'AddressCountry_' + formId;
    var provinceSelector = 'AddressProvince_' + formId;
    var containerSelector = 'AddressProvinceContainer_' + formId;

    new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
      hideElement: containerSelector
    });
  });

  // Toggle new/edit address forms
  $('.address-new-toggle').on('click', function() {
    $newAddressForm.toggleClass('hide');
  });

  $('.address-edit-toggle').on('click', function () {
    var formId = $(this).data('form-id');
    $('#EditAddress_' + formId).toggleClass('hide');
  });

  $('.address-delete').on('click', function() {
    var $el = $(this);
    var formId = $el.data('form-id');
    var confirmMessage = $el.data('confirm-message');
    if (confirm(confirmMessage || "Are you sure you wish to delete this address?")) {
      Shopify.postLink('/account/addresses/' + formId, {'parameters': { '_method': 'delete' }});
    }
  });
};

/**
 *  Check URL for reset password hash
 */
ShopifyCanvas.checkUrlHash = function () {
  var hash = ShopifyCanvas.getHash();

  // Allow deep linking to recover password form
  if (hash == '#recover') {
    ShopifyCanvas.toggleRecoverPasswordForm();
  }
};

/**
 *  Get the hash from the URL
 */
ShopifyCanvas.getHash = function () {
  return window.location.hash;
};

// Initialize ShopifyCanvas's JS on docready
$(ShopifyCanvas.init);

theme.strings = {
  addToCart: "Add to cart",
  preorderAddToCart: "Translation missing: en.products.product.preorder_add_to_cart",
  soldOut: "Sold out"
};

/*
 * Returns a function which adds a vendor prefix to any CSS property name
 * Source https://github.com/markdalgleish/stellar.js/blob/master/src/jquery.stellar.js
 */
var vendorPrefix = (function () {
  var prefixes = /^(Moz|Webkit|O|ms)(?=[A-Z])/,
      style = $('script')[0].style,
      prefix = '',
      prop;

  for (prop in style) {
    if (prefixes.test(prop)) {
      prefix = prop.match(prefixes)[0];
      break;
    }
  }

  if ('WebkitOpacity' in style) { prefix = 'Webkit'; }
  if ('KhtmlOpacity' in style) { prefix = 'Khtml'; }

  return function (property) {
    return prefix + (prefix.length > 0 ? property.charAt(0).toUpperCase() + property.slice(1) : property);
  };
}());

/*
 * Shopify JS for customizing Slick.js
 *   http://kenwheeler.github.io/slick/
 *   Untouched JS in src/javascripts/slick.min.js (dev)
 *   Added to the top of this file in production

 * Requires $.debounce function from theme.js
 */
var slickTheme = (function(module, $) {
  'use strict';

  // Public functions
  var init, onInit, beforeChange, afterChange;

  // Private variables
  var settings, $slider, $allSlides, $activeSlide, $slickDots, windowHeight, scrolled, $heroImage, prefixedTransform;
  var currentActiveSlide = 0;

  // Private functions
  var cacheObjects, setFullScreen, sizeFullScreen, setParallax, calculateParallax;

  /*============================================================================
  Initialise the plugin and define global options
  ==============================================================================*/
  cacheObjects = function () {
    slickTheme.cache = {
      $html      : $('html'),
      $window    : $(window),

      $heroImage : $('.hero__image')
    };

    slickTheme.vars = {
      slideClass      : 'slick-slide',
      activeClass     : 'slick-active',
      hiddenClass     : 'hero__slide--hidden',
      heroHeaderClass : 'hero__header'
    };
  };

  init = function (options) {
    cacheObjects();

    // Default settings
    settings = {
      // User options
      $element       : null,
      $headerClass   : null,

      // Private settings
      isTouch        : slickTheme.cache.$html.hasClass('supports-touch') ? true : false,

      // Slick options
      arrows         : false,
      dots           : false,
      adaptiveHeight : true,
      autoplay       : true,
      autoplaySpeed  : 7000,
      speed          : 3000
    };

    // Override defaults with arguments
    $.extend(settings, options);

    /*
    * Init slick slider
    *   - Add any additional option changes here
    *   - https://github.com/kenwheeler/slick/#options
    */
    settings.$element.slick({
      arrows         : settings.arrows,
      dots           : settings.dots,
      draggable      : false,
      fade           : true,
      autoplay       : settings.autoplay,
      autoplaySpeed  : settings.autoplaySpeed,
      speed          : settings.speed,
      pauseOnHover   : false,
      onInit         : this.onInit,
      onBeforeChange : this.beforeChange,
      onAfterChange  : this.afterChange
    });
  };

  onInit = function (obj) {
    $slider = obj.$slider;
    $allSlides = $slider.find('.' + slickTheme.vars.slideClass);
    $activeSlide = $slider.find('.' + slickTheme.vars.activeClass);
    $slickDots = $slider.find('.slick-dots');

    if (!settings.isTouch) {
      $allSlides.addClass(slickTheme.vars.hiddenClass);
      $activeSlide.removeClass(slickTheme.vars.hiddenClass);
    }

    setFullScreen();

    if (slickTheme.cache.$html.hasClass('supports-csstransforms3d')) {
      setParallax();
    }

    //trigger event that slick has initialized
    slickTheme.cache.$window.trigger('slick-initialized');
  };

  beforeChange = function (evt, currentSlide, nextSlide) {
    if (!settings.isTouch) {
     $allSlides.removeClass(slickTheme.vars.hiddenClass);
    }

    // Set upcoming slide as index
    currentActiveSlide = nextSlide;

    // Set new active slide to proper parallax position
    if (slickTheme.cache.$html.hasClass('supports-csstransforms3d')) {
     calculateParallax(currentActiveSlide);
    }
  };

  afterChange = function (evt, currentSlide) {
    if (!settings.isTouch) {
      $activeSlide = $slider.find('.' + slickTheme.vars.activeClass);
      $allSlides.addClass(slickTheme.vars.hiddenClass);
      $activeSlide.removeClass(slickTheme.vars.hiddenClass);
    }
  };

  setFullScreen = function () {
    sizeFullScreen();

    // Resize hero after screen resize
    slickTheme.cache.$window.on('resize', $.debounce(250, sizeFullScreen));
  };

  sizeFullScreen = function () {
    windowHeight = slickTheme.cache.$window.height();
    settings.$element.css('height', windowHeight);
  };

  setParallax = function () {
    prefixedTransform = vendorPrefix ? vendorPrefix('transform') : 'transform';

    slickTheme.cache.$window.on('scroll', function(evt) {
      calculateParallax(currentActiveSlide);
    });
  };

  calculateParallax = function (currentSlide) {
    scrolled = slickTheme.cache.$window.scrollTop();

    if (slickTheme.cache.$heroImage[currentSlide]) {
      slickTheme.cache.$heroImage[currentSlide].style[prefixedTransform] = 'translate3d(0, ' + scrolled / 4.5 + 'px, 0)';
    }
  };

  module = {
    init: init,
    onInit: onInit,
    beforeChange: beforeChange,
    afterChange: afterChange
  };

  return module;

}(slickTheme || {}, jQuery));

/*============================================================================
  Drawer modules
==============================================================================*/
theme.Drawers = (function () {
  var Drawer = function (id, position, options) {
    var defaults = {
      close: '.js-drawer-close',
      open: '.js-drawer-open-' + position,
      openClass: 'js-drawer-open',
      dirOpenClass: 'js-drawer-open-' + position
    };

    this.$nodes = {
      parent: $('body, html'),
      page: $('#PageContainer')
    };

    this.config = $.extend(defaults, options);
    this.position = position;

    this.$drawer = $('#' + id);

    if (!this.$drawer.length) {
      return false;
    }

    this.drawerIsOpen = false;
    this.init();
  };

  Drawer.prototype.init = function () {
    $(this.config.open).on('click', $.proxy(this.open, this));
    this.$drawer.on('click', this.config.close, $.proxy(this.close, this));
  };

  Drawer.prototype.open = function (evt) {
    // Keep track if drawer was opened from a click, or called by another function
    var externalCall = false;

    // Prevent following href if link is clicked
    if (evt) {
      evt.preventDefault();
    } else {
      externalCall = true;
    }

    // Without this, the drawer opens, the click event bubbles up to $nodes.page
    // which closes the drawer.
    if (evt && evt.stopPropagation) {
      evt.stopPropagation();
      // save the source of the click, we'll focus to this on close
      this.$activeSource = $(evt.currentTarget);
    }

    if (this.drawerIsOpen && !externalCall) {
      return this.close();
    }

    // Add is-transitioning class to moved elements on open so drawer can have
    // transition for close animation
    this.$drawer.prepareTransition();

    this.$nodes.parent.addClass(this.config.openClass + ' ' + this.config.dirOpenClass);
    this.drawerIsOpen = true;

    // Set focus on drawer
    this.trapFocus({
      $container: this.$drawer,
      $elementToFocus: this.$drawer.find('.drawer__close-button'),
      namespace: 'drawer_focus'
    });

    // Run function when draw opens if set
    if (this.config.onDrawerOpen && typeof(this.config.onDrawerOpen) == 'function') {
      if (!externalCall) {
        this.config.onDrawerOpen();
      }
    }

    if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
      this.$activeSource.attr('aria-expanded', 'true');
    }

    this.$nodes.parent.on('keyup.drawer', $.proxy(function (evt) {
      // close on 'esc' keypress
      if (evt.keyCode === 27) {
        this.close();
        return false;
      }
    }, this));

    // Lock scrolling on mobile
    this.$nodes.page.on('touchmove.drawer', function () {
      return false;
    });

    this.$nodes.page.on('click.drawer', $.proxy(function () {
      this.close();
      return false;
    }, this));
  };

  Drawer.prototype.close = function () {
    if (!this.drawerIsOpen) { // don't close a closed drawer
      return;
    }

    // deselect any focused form elements
    $(document.activeElement).trigger('blur');

    // Ensure closing transition is applied to moved elements, like the nav
    this.$drawer.prepareTransition();

    this.$nodes.parent.removeClass(this.config.dirOpenClass + ' ' + this.config.openClass);

    // Remove scroll prevention
    $('body, html, .bbs-page-container, .bbs-drawer-overlay').off('.drawer');

    this.drawerIsOpen = false;

    // Remove focus on drawer
    this.removeTrapFocus({
      $container: this.$drawer,
      namespace: 'drawer_focus'
    });

    this.$nodes.page.off('.drawer');
    this.$nodes.parent.off('.drawer');
  };

  /**
  * Traps the focus in a particular container
  *
  * @param {object} options - Options to be used
  * @param {jQuery} options.$container - Container to trap focus within
  * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
  * @param {string} options.namespace - Namespace used for new focus event handler
  */
  Drawer.prototype.trapFocus = function (options) {
    var eventName = options.eventNamespace
      ? 'focusin.' + eventNamespace
      : 'focusin';

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
    }

    options.$container.attr('tabindex', '-1');
    options.$elementToFocus.focus();

    $(document).on(eventName, function (evt) {
      if (options.$container[0] !== evt.target && !options.$container.has(evt.target).length) {
        options.$container.focus();
      }
    });
  };

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  Drawer.prototype.removeTrapFocus = function (options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (options.$container && options.$container.length) {
      options.$container.removeAttr('tabindex');
    }

    $(document).off(eventName);
  };

  return Drawer;
})();

theme.ActionBar = (function() {
  function init() {
    cacheSelectors();
    initStickyActionBar();
    initActionBar();

    theme.cache.$window.on('resize', $.debounce(250, resizeEvents));
  }

  function cacheSelectors() {
    var cache = {

      $actionBar : $('.action-bar'),
      $actionArea : $('.action-area'),
      $actionBarWrapper : $('.action-bar-wrapper'),
      $actionBarMenus: $('.action-bar__menu'),
      $actionBarMenuHasDropdown: $('.action-bar--has-dropdown'),
      $activeActionBarHasSubMenu: $('.action-bar--has-dropdown.action-bar--active'),
      $actionBarMainMenu: $('.action-bar__menu--main'),
      $actionBarSubMenus: $('.action-bar__menu--sub'),
      $actionBarBack: $('.action-bar__back'),
      $actionBarMainMenuFirst: $('.action-bar__menu--main .action-bar__link').eq(0)

    };

    $.extend(theme.cache, cache);

    var variables = {
      previousScrollPosition: 0,
      hasActionBar: theme.cache.$actionBar.length,
      actionBarOffsetTop: 0,
      actionBarOffsetBottom: 0,
      stickyClass: 'js-sticky-action-bar',
      actionBarOpenTransitionClass: 'js-sticky-action-bar--open',
    };

    $.extend(theme.variables, variables);
  }

  function initActionBar() {
    actionBarScroll();

    if (theme.cache.$actionBarMenuHasDropdown.length) {
      actionBarDropdowns();
    }

    theme.cache.$window.on('resize', $.debounce(500, actionBarScroll));
  }

  function actionBarDropdowns() {
    var $activeSubNavItem = theme.cache.$actionBarSubMenus.find('.action-bar--active');
    var $activeSubNavTarget = theme.cache.$activeActionBarHasSubMenu.attr('data-child-list-handle');
    var showClass = 'action-bar--show';

    theme.cache.$actionBarBack.on('click', closeSubNav);

    // Prevent Click Event on action bar links which have submenus if they
    // are active
    theme.cache.$actionBarMainMenu.on('click', '.action-bar--disabled', function (evt) {
      evt.preventDefault();

      openSubNavFromNavItem();
    });

    if ($activeSubNavItem.length) {
      openSubNavFromSubNavItem();
    }

    /*
      Open SubNav if there is an active Parent with a dropdown in the action bar
     */
    function openSubNavFromNavItem () {
      theme.cache.$actionBarMainMenu.removeClass(showClass);

      // loop through any dropdowns that exist
      theme.cache.$actionBarSubMenus.each(function () {
        var $el = $(this);

        if ($activeSubNavTarget === $el.attr('data-child-list-handle')) {
          $el
            .prepareTransition()
            .addClass(showClass);
          theme.setFocus($el.find('.action-bar__link').eq(0), 'action-bar');
        }
      });

      actionBarScroll();
    }

    /*
      Open SubNav if one of the action bar subnav links is active
     */
    function openSubNavFromSubNavItem () {
      //select the first active subnav item (uses .last() because jQuery)
      var $activeSubNav = $activeSubNavItem.parents('.action-bar__menu--sub').last();

      theme.cache.$actionBarMainMenu.removeClass(showClass);
      $activeSubNav.addClass(showClass);

      // find parent menu item and mark it active
      theme.cache.$actionBarMenuHasDropdown.each(function () {
        var $el = $(this);
        var menuHandle = $el.attr('data-child-list-handle');

        if (menuHandle == $activeSubNav.attr('data-child-list-handle')) {
          $el.addClass('action-bar--disabled');

          //update the active parent childListHandle
          $activeSubNavTarget = menuHandle;
        }
      });

      actionBarScroll();
    };

    function closeSubNav () {
      theme.cache.$actionBarSubMenus.removeClass(showClass);
      theme.cache.$actionBarMainMenu
        .prepareTransition()
        .addClass(showClass);
      theme.setFocus(theme.cache.$actionBarMainMenuFirst, 'action-bar');
      actionBarScroll();
    };

  }

  function actionBarScroll() {

    // set dynamic variables which might have changed since the last time
    // actionBarScroll() was called
    var $activeActionBar = $('.action-bar--show');
    var activeActionBarWidth = $activeActionBar.width();
    //set action bar to be scrollable

    if (activeActionBarWidth > theme.variables.windowWidth) {
      var $activeLink = $activeActionBar.find('.action-bar--active');

      theme.cache.$actionBarWrapper.addClass('scrollable-js');

      //only scroll if a link is marked active
      if ($activeLink.length) {
        var activeOffset = $activeLink.offset().left;
        var scrollToLink = 0;

        if (activeOffset > theme.variables.windowWidth / 2) {
          scrollToLink = activeOffset - theme.variables.windowWidth / 3;

          theme.cache.$actionBar.animate({
            scrollLeft: scrollToLink
          });
        }
      }
    } else {
      theme.cache.$actionBarWrapper.removeClass('scrollable-js');
      theme.cache.$actionBar.animate({
        scrollLeft: 0
      });
    }

    theme.cache.$actionBar.on('scroll', $.throttle(100, scrollPosition));

    function scrollPosition () {
      var leftEdge = $activeActionBar.offset().left;

      // Make sure we've scrolled passed a buffer of 100px
      if (leftEdge < -100) {
        theme.cache.$actionBarWrapper.addClass('scrolled');
      } else {
        theme.cache.$actionBarWrapper.removeClass('scrolled');
      }
    }
  }

  function resizeEvents() {

    var windowWidth = theme.cache.$window.width();

    if (windowWidth === theme.variables.windowWidth) {
      return;
    }

    theme.variables.windowWidth = windowWidth;
    setStickyActionBarVariables();
  }

  function initStickyActionBar() {

    if (!theme.cache.$actionBar.length) {
      resizeHeader();
      return;
    }

    // if there is a slideshow we need to reset the 'top' of the page
    // to the bottom of the slideshow
    if (theme.cache.$hero.length) {
      theme.cache.$window.on('slick-initialized', function () {
        theme.cache.$heroWrapper.addClass('hero-initialized');
        setStickyActionBarVariables();
        stickyActionBar();
        theme.cache.$window.on('scroll', stickyActionBar);
      });
    } else {
      setStickyActionBarVariables();
      stickyActionBar();
      theme.cache.$window.on('scroll', stickyActionBar);
    }
  }

  function setStickyActionBarVariables() {

    if (!theme.cache.$actionBar.length) {
      return;
    }

    theme.variables.actionBarOffsetTop = theme.cache.$actionBar.offset().top;
    theme.variables.actionBarOffsetBottom = theme.cache.$actionBar.height() + theme.cache.$actionBar.offset().top;

    resizeHeader();

  }

  function resizeHeader() {

    var siteHeaderHeight = theme.cache.$siteHeader.height();

    // prevent content from jumping when we show/hide the header on non-index pages
    if (!theme.variables.isIndexTemplate) {
      theme.cache.$siteHeaderWrapper.css('height', siteHeaderHeight);
    }

  }

  function stickyActionBar() {

    var currentScrollTop = theme.cache.$window.scrollTop();

    // scroll down && we're below the header
    if (currentScrollTop > theme.variables.previousScrollPosition && currentScrollTop > theme.variables.actionBarOffsetBottom) {

      theme.cache.$body.addClass(theme.variables.stickyClass);

      var scrollTimeout = setTimeout(function() {
        theme.cache.$body.addClass(theme.variables.actionBarOpenTransitionClass);
      }, 50);
      theme.variables.previousScrollPosition = currentScrollTop;
    }

    // scroll Up
    if (currentScrollTop < theme.variables.previousScrollPosition) {
      clearTimeout(scrollTimeout);

      // show the regular ol' site header at the top of the page
      if (currentScrollTop <= theme.variables.actionBarOffsetTop) {
        theme.cache.$body
          .removeClass(theme.variables.stickyClass)
          .removeClass(theme.variables.actionBarOpenTransitionClass);
        theme.variables.previousScrollPosition = currentScrollTop;
      }
    }
  }

  return {
    init: init
  };

})();




theme.Collection = (function() {

  var selectors = {
    collectionGrid: '.collection-grid',
    collectionSort: '#SortBy',
    tagSort: '#SortTags',
    showMoreButton: '.js-show-more'
  };

  function init() {
    cacheSelectors();
    collectionSorting();
    tagSorting();
    initPagination();
  }

  function cacheSelectors() {
    var cache = {
      $collectionGrid: $(selectors.collectionGrid),
      $collectionSort: $(selectors.collectionSort),
      $tagSort: $(selectors.tagSort),
      $showMoreButton: $(selectors.showMoreButton)
    };

    $.extend(theme.cache, cache);
  }

  function collectionSorting() {
    theme.queryParams = {};
    var $sort = theme.cache.$collectionSort;

    if(!$sort.length) {
      return;
    }

    if (location.search.length) {
      for (var aKeyValue, i = 0, aCouples = location.search.substr(1).split('&'); i < aCouples.length; i++) {
        aKeyValue = aCouples[i].split('=');
        if (aKeyValue.length > 1) {
          theme.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
        }
      }
    }

    // Enable sorting with current sort order as value
    $sort.val($sort.attr('data-value')).on('change', function() {
      theme.queryParams.sort_by = $(this).val();
      location.search = $.param(theme.queryParams).replace(/\+/g, '%20');
    });
  }

  function tagSorting () {
    theme.cache.$tagSort.on('change', function() {
      var val = $(this).val();
      if (val) {
        window.location.href = $(this).val();
      }
    });
  }

  function initPagination() {
    if(!theme.cache.$showMoreButton.length) {
      return;
    }

    theme.cache.$showMoreButton.on('click', paginate);
  }

  function paginate(evt) {
    evt.preventDefault();

    // only send on ajax request at a time
    if (theme.cache.$showMoreButton.hasClass('btn--ajax-disabled') || theme.cache.$showMoreButton.hasClass('btn--disabled')) {
      return;
    }

    theme.cache.$showMoreButton.addClass('btn--ajax-disabled');

    $.ajax({
      url: theme.cache.$showMoreButton.attr('href'),
      type: 'GET',
      dataType: 'html'
    })
    .done(function(data) {
      var $data = $(data);
      var $newItems = $data.find('.product-item');
      var showMoreUrl = $data.find('.js-show-more').attr('href');

      theme.cache.$collectionGrid.append($newItems);

      //update grid items selector so that the imagesLoaded plugin knows about them
      theme.cache.$productGridItem = $('.product-item');

      if (showMoreUrl.length) {
        theme.cache.$showMoreButton.attr('href', showMoreUrl);
      } else {
        theme.cache.$showMoreButton.addClass('btn--disabled');
      }
    })
    .always(function () {
      theme.cache.$showMoreButton.removeClass('btn--ajax-disabled');
    });
  }

  return {
    init: init
  };

})();

/*============================================================================
  Ajax the add to cart experience by revealing it in a side drawer
  (c) Copyright 2015 Shopify Inc. All Rights Reserved.

  This requires:
    - jQuery 1.11+
    - handlebars.min.js (for cart template)
    - modernizer.min.js
    - snippet/ajax-cart-template.liquid

    (refer to vendor.js)
==============================================================================*/

/*============================================================================
  Override POST to cart/add.js. Returns cart JSON.
    - Allow use of form element instead of just id
    - Allow custom error callback
==============================================================================*/
Shopify.addItemFromForm = function(form, callback, errorCallback) {
  var params = {
    type: 'POST',
    url: '/cart/add.js',
    data: jQuery(form).serialize(),
    dataType: 'json',
    success: function(line_item) {
      if ((typeof callback) === 'function') {
        callback(line_item, form);
      }
      else {
        Shopify.onItemAdded(line_item, form);
      }
    },
    error: function(XMLHttpRequest, textStatus) {
      if ((typeof errorCallback) === 'function') {
        errorCallback(XMLHttpRequest, textStatus);
      }
      else {
        Shopify.onError(XMLHttpRequest, textStatus);
      }
    }
  };
  jQuery.ajax(params);
};

/*============================================================================
  Override POST to cart/change.js. Returns cart JSON.
    - Use product's line in the cart instead of ID so custom
      product properties are supported.
==============================================================================*/
Shopify.changeItem = function(line, quantity, callback) {
  var params = {
    type: 'POST',
    url: '/cart/change.js',
    data: 'quantity=' + quantity + '&line=' + line,
    dataType: 'json',
    success: function(cart) {
      if ((typeof callback) === 'function') {
        callback(cart);
      }
      else {
        Shopify.onCartUpdate(cart);
      }
    },
    error: function(XMLHttpRequest, textStatus) {
      Shopify.onError(XMLHttpRequest, textStatus);
    }
  };
  jQuery.ajax(params);
};

/*============================================================================
  GET cart.js returns the cart in JSON.
==============================================================================*/
Shopify.getCart = function(callback) {
  jQuery.getJSON('/cart.js', function (cart, textStatus) {
    if ((typeof callback) === 'function') {
      callback(cart);
    }
    else {
      Shopify.onCartUpdate(cart);
    }
  });
};

/*============================================================================
  Ajax Shopify Add To Cart
==============================================================================*/
var ajaxCart = (function(module, $) {

  'use strict';

  // Public functions
  var init, loadCart;

  // Private general variables
  var settings, isUpdating, $body;

  // Private plugin variables
  var $formContainer, $errorsContainer, $addToCart, $cartCountSelector, $cartCostSelector, $cartContainer, $drawerContainer;

  // Private functions
  var updateCountPrice, formOverride, itemAddedCallback, itemErrorCallback, cartUpdateCallback, buildCart, cartCallback, adjustCart, adjustCartCallback, qtySelectors, validateQty;

  /*============================================================================
    Initialise the plugin and define global options
  ==============================================================================*/
  init = function (options) {

    // Default settings
    settings = {
      formSelector       : 'form[action^="/cart/add"]',
      errorSelector      : '.product-single__errors',
      cartContainer      : '#CartContainer',
      addToCartSelector  : 'button[type="submit"]',
      cartCountSelector  : '.hl-cart-count',
      cartCostSelector   : null,
      moneyFormat        : '',
      disableAjaxCart    : false,
      enableQtySelectors : true
    };

    // Override defaults with arguments
    $.extend(settings, options);

    // Select DOM elements
    $formContainer     = $(settings.formSelector);
    $errorsContainer   = $(settings.errorSelector);
    $cartContainer     = $(settings.cartContainer);
    $addToCart         = $formContainer.find(settings.addToCartSelector);
    $cartCountSelector = $(settings.cartCountSelector);
    $cartCostSelector  = $(settings.cartCostSelector);

    // General Selectors
    $body = $('body');

    // Track cart activity status
    isUpdating = false;

    // Setup ajax quantity selectors on the any template if enableQtySelectors is true
    if (settings.enableQtySelectors) {
      qtySelectors();
    }

    // Take over the add to cart form submit action if ajax enabled
    if (!settings.disableAjaxCart && $addToCart.length) {
      formOverride();
    }

    // Run this function in case we're using the quantity selector outside of the cart
    adjustCart();
  };

  loadCart = function () {
    $body.addClass('drawer--is-loading');
    Shopify.getCart(cartUpdateCallback);
  };

  updateCountPrice = function (cart) {
    if ($cartCountSelector) {
      $cartCountSelector.html(cart.item_count).removeClass('hidden-count');

      if (cart.item_count === 0) {
        $cartCountSelector.addClass('hidden-count');
      }
    }

    if ($cartCostSelector) {
      $cartCostSelector.html(Shopify.formatMoney(cart.total_price, settings.moneyFormat));
    }
  };

  formOverride = function () {
    $formContainer.on('submit', function(evt) {
      evt.preventDefault();

      // Add class to be styled if desired
      $addToCart.removeClass('is-added').addClass('is-adding');

      // Remove any previous quantity errors
      $('.qty-error').remove();

      Shopify.addItemFromForm(evt.target, itemAddedCallback, itemErrorCallback);
    });
  };

  itemAddedCallback = function (product) {
    $addToCart.removeClass('is-adding').addClass('is-added');

    Shopify.getCart(cartUpdateCallback);
  };

  itemErrorCallback = function (XMLHttpRequest, textStatus) {
    var data = eval('(' + XMLHttpRequest.responseText + ')');
    $addToCart.removeClass('is-adding is-added');

    $cartContainer.trigger('ajaxCart.updatedQty');

    if (!!data.message) {
      if (data.status == 422) {
        $errorsContainer.html('<div class="errors qty-error">'+ data.description +'</div>');
      }
    }
  };

  cartUpdateCallback = function (cart) {
    // Update quantity and price
    updateCountPrice(cart);
    buildCart(cart);
  };

  buildCart = function (cart) {
    // Start with a fresh cart div
    $cartContainer.empty();

    // Show empty cart
    if (cart.item_count === 0) {

      // @todo @note HERE IS ANOTHER PLACE LIQUID IS USED
      var continueButtonHTML = $('#JsContinueBtn').html()
      $cartContainer
        .append('<p class="cart-empty">' + "Your cart is currently empty." + '</p>')
      	.append(continueButtonHTML);
      cartCallback(cart);
      return;
    }

    // Handlebars.js cart layout
    var items = [],
        item = {},
        data = {},
        source = $("#CartTemplate").html(),
        template = Handlebars.compile(source);

    // Add each item to our handlebars.js data
    $.each(cart.items, function(index, cartItem) {

      /* Hack to get product image thumbnail
       *   - If image is not null
       *     - Remove file extension, add _small, and re-add extension
       *     - Create server relative link
       *   - A hard-coded url of no-image
      */
      if (cartItem.image != null){
        var prodImg = cartItem.image.replace(/(\.[^.]*)$/, "_grande$1").replace('http:', '');
      } else {
        var prodImg = "//cdn.shopify.com/s/assets/admin/no-image-medium-cc9732cb976dd349a0df1d39816fbcc7.gif";
      }

      if (cartItem.properties !== null) {
        $.each(cartItem.properties, function(key, value) {
          if (key.charAt(0) === '_' || !value) {
            delete cartItem.properties[key];
          }
        });
      }

      // Create item's data object and add to 'items' array
      item = {
        key: cartItem.key,
        line: index + 1, // Shopify uses a 1+ index in the API
        url: cartItem.url,
        img: prodImg,
        name: cartItem.product_title,
        variation: cartItem.variant_title,
        size: cartItem.variant_options[0],
        itemInventory: cartItem.variant_options[0].inventory_quantity,
        properties: cartItem.properties,
        itemAdd: cartItem.quantity + 1,
        itemMinus: cartItem.quantity - 1,
        itemQty: cartItem.quantity,
        price: Shopify.formatMoney(cartItem.price, settings.moneyFormat),
        vendor: cartItem.vendor,
        linePrice: Shopify.formatMoney(cartItem.line_price, settings.moneyFormat),
        originalLinePrice: Shopify.formatMoney(cartItem.original_line_price, settings.moneyFormat),
        discounts: cartItem.discounts,
        discountsApplied: cartItem.line_price === cartItem.original_line_price ? false : true
      };

      items.push(item);
    });

    // @todo @note HERE IS ANOTHER PLACE LIQUID IS USED
    // Gather all cart data and add to DOM
    data = {
      items: items,
      note: cart.note,
      totalPrice: Shopify.formatMoney(cart.total_price, settings.moneyFormat),
      totalCartDiscount: cart.total_discount === 0 ? 0 : "You're saving [savings]".replace('[savings]', Shopify.formatMoney(cart.total_discount, settings.moneyFormat)),
      totalCartDiscountApplied: cart.total_discount === 0 ? false : true
    }

    $cartContainer.append(template(data));

    cartCallback(cart);
  };

  cartCallback = function(cart) {
    $body.removeClass('drawer--is-loading');
    $cartContainer.trigger('ajaxCart.afterCartLoad', cart);

    if (window.Shopify && Shopify.StorefrontExpressButtons) {
      Shopify.StorefrontExpressButtons.initialize();
    }
  };

  adjustCart = function () {
    // Delegate all events because elements reload with the cart

    // Add or remove from the quantity
    $cartContainer.on('click', '.ajaxcart__qty-adjust', function() {
      if (isUpdating) {
        return;
      }

      var $el = $(this),
          line = $el.data('line'),
          $qtySelector = $el.siblings('.ajaxcart__qty-num'),
          qty = parseInt($qtySelector.val().replace(/\D/g, ''));

      var qty = validateQty(qty);

      // Add or subtract from the current quantity
      if ($el.hasClass('ajaxcart__qty--plus')) {
        qty += 1;
      } else {
        qty -= 1;
        if (qty <= 0) qty = 0;
      }

      // If it has a data-line, update the cart.
      // Otherwise, just update the input's number
      if (line) {
        updateQuantity(line, qty);
      } else {
        $qtySelector.val(qty);
      }
    });

    // Update quantity based on input on change
    $cartContainer.on('change', '.ajaxcart__qty-num', function() {
      if (isUpdating) {
        return;
      }

      var $el = $(this),
          line = $el.data('line'),
          qty = parseInt($el.val().replace(/\D/g, ''));

      var qty = validateQty(qty);

      // If it has a data-line, update the cart
      if (line) {
        updateQuantity(line, qty);
      }
    });

    // Remove line based on clicking X
    $cartContainer.on('click', '.ajaxcart__delete-cross', function() {
      if (isUpdating) {
        return;
      }

      var $el = $(this),
          line = $el.data('line'),
          // Update quantity to 0 (i.e. delete line)
          qty = 0;

      var qty = validateQty(qty);

      // If it has a data-line, update the cart
      if (line) {
        updateQuantity(line, qty);
      }
    });

    $cartContainer.on('focus', '.ajaxcart__qty-num', function(evt) {
      var $el = $(evt.target);
      $el[0].setSelectionRange(0, $el[0].value.length);
    });

    // Prevent cart from being submitted while quantities are changing
    $cartContainer.on('submit', 'form.ajaxcart', function(evt) {
      if (isUpdating) {
        evt.preventDefault();
      }
    });

    // Highlight the text when focused
    $cartContainer.on('focus', '.ajaxcart__qty-adjust', function() {
      var $el = $(this);
      setTimeout(function() {
        $el.select();
      }, 50);
    });

    function updateQuantity(line, qty) {
      isUpdating = true;

      // Add activity classes when changing cart quantities
      var $product = $('.ajaxcart__product[data-line="' + line + '"]').addClass('is-loading');

      if (qty === 0) {
        $product.parent().addClass('is-removed');
      }

      // Slight delay to make sure removed animation is done
      setTimeout(function() {
        Shopify.changeItem(line, qty, adjustCartCallback);
      }, 250);

      $cartContainer.trigger('ajaxCart.updatingQty');
    }

    // Save note anytime it's changed
    $cartContainer.on('change', 'textarea[name="note"]', function() {
      var newNote = $(this).val();

      // Update the cart note in case they don't click update/checkout
      Shopify.updateCartNote(newNote, function(cart) {});
    });
  };

  adjustCartCallback = function (cart) {
    // Update quantity and price
    updateCountPrice(cart);

    // Reprint cart on short timeout so you don't see the content being removed
    setTimeout(function() {
      isUpdating = false;
      Shopify.getCart(buildCart);
    }, 150)
  };

  qtySelectors = function() {
    // Change number inputs to JS ones, similar to ajax cart but without API integration.
    // Make sure to add the existing name and id to the new input element
    var numInputs = $('input[type="number"]');

    // Qty selector has a minimum of 1 on the product page
    // and 0 in the cart (determined on qty click)
    var qtyMin = 0;

    if (numInputs.length) {
      numInputs.each(function() {
        var $el = $(this),
            currentQty = $el.val(),
            inputName = $el.attr('name'),
            inputId = $el.attr('id');

        var itemAdd = currentQty + 1,
            itemMinus = currentQty - 1,
            itemQty = currentQty;

        var source   = $("#JsQty").html(),
            template = Handlebars.compile(source),
            data = {
              key: $el.data('id'),
              itemQty: itemQty,
              itemAdd: itemAdd,
              itemMinus: itemMinus,
              inputName: inputName,
              inputId: inputId
            };

        // Append new quantity selector then remove original
        $el.after(template(data)).remove();
      });

      // Setup listeners to add/subtract from the input
      $('.js-qty__adjust').on('click', function() {
        var $el = $(this),
            id = $el.data('id'),
            $qtySelector = $el.siblings('.js-qty__num'),
            qty = parseInt($qtySelector.val().replace(/\D/g, ''));

        var qty = validateQty(qty);
        qtyMin = $body.hasClass('template-product') ? 1 : qtyMin;

        // Add or subtract from the current quantity
        if ($el.hasClass('js-qty__adjust--plus')) {
          qty += 1;
        } else {
          qty -= 1;
          if (qty <= qtyMin) qty = qtyMin;
        }

        // Update the input's number
        $qtySelector.val(qty);
      });
    }
  };

  validateQty = function (qty) {
    if((parseFloat(qty) == parseInt(qty)) && !isNaN(qty)) {
      // We have a valid number!
    } else {
      // Not a number. Default to 1.
      qty = 1;
    }
    return qty;
  };

  module = {
    init: init,
    load: loadCart
  };

  return module;

}(ajaxCart || {}, jQuery));

/*================ SECTIONS ================*/
theme.SlideshowSection = (function() {

  function SlideshowSection(container) {
    var $container = this.$container = $(container);
    var sectionId = $container.attr('data-section-id');
    var slideshow = this.slideshow = '#Hero';
    var $slideshowImages = $container.find('.hero__image');

    slickTheme.init({
      $element: $(slideshow),
      $headerClass: $('.site-header-wrapper'), // absolutely positioned inside $element
      speed: 1000,
      autoplaySpeed: 4000
    });

    $slideshowImages.imagesLoaded({ background: true })
      .progress(function (instance, image) {
        var $el = $(image.element).addClass('image-loaded');
      });

    theme.drawersInit();
  }

  return SlideshowSection;
})();

theme.SlideshowSection.prototype = _.assignIn({}, theme.SlideshowSection.prototype, {
  onUnload: function() {
    $(this.slideshow).unslick();
  },

  onSelect: function() {
    theme.LeftDrawer.close();
  },

  onBlockSelect: function(evt) {
    var $slide = $('.hero__slide--' + evt.detail.blockId);
    var slideIndex = $slide.attr('index');

    $(this.slideshow).slickGoTo(slideIndex).slickPause();
  },

  onBlockDeselect: function() {
    $(this.slideshow).slickPlay();
  }
});

theme.SidebarMenuSection = (function() {

  function SidebarMenuSection(container) {
      $('.drawer-nav__toggle').on('click', function() {
        $(this).parent().toggleClass('drawer-nav--expanded');
      });
  }

  return SidebarMenuSection;
})();

theme.SidebarMenuSection.prototype = _.assignIn({}, theme.SidebarMenuSection.prototype, {

  onSelect: function() {
    theme.RightDrawer.close();
    theme.SearchDrawer.close();
    theme.LeftDrawer.open();
  },

  onDeselect: function() {
    theme.LeftDrawer.close();
  }

});

theme.HeaderSection = (function() {

  function HeaderSection() {
    theme.drawersInit();
  }

  return HeaderSection;
})();

theme.HeaderSection.prototype = _.assignIn({}, theme.HeaderSection.prototype, {
  onSelect: function() {
    theme.LeftDrawer.close();
  }
});

theme.ActionBarSection = (function() {

  function ActionBarSection() {
    theme.ActionBar.init();
  }

  return ActionBarSection;

})();

theme.ActionBarSection.prototype = _.assignIn({}, theme.ActionBarSection.prototype, {
  onSelect: function() {
    theme.LeftDrawer.close();
  }
});
theme.CollectionTemplate = (function() {

  function CollectionTemplate(container) {

    theme.Collection.container = container;
    theme.Collection.init();

  }

  return CollectionTemplate;

})();



/* eslint-disable no-new */
theme.Product = (function() {

  var settings = {
    imageSize: null
  };

  var selectors = {
    addToCart: '.add-to-cart',
    addToCartText: '.add-to-cart__text',
    cartContainer: '#CartContainer',
    originalSelectorId: 'ProductSelect', // @note 'product-select' used, see initVariantSelectors
    productForm: '#AddToCartForm',
    productPrice: '.product__price--reg',
    productReturnLink: '.return-link',
    salePrice: '.product__price .js-price',
    salePriceWrapper: '.product__price--sale',
    variantImage: '.product__photo--variant',
    // @note product image switcher
    productImageTiles: $('.hl-main-image-tiles').find('a.hl-secondary-photo'),
    productImages: $('.product__photo-slider'),
    productMainImage: $('.product-detail-main-image')
  };

  function Product(container) {
    var $container = this.$container = $(container);
    var sectionId = $container.attr('data-section-id');

    this.settings = $.extend({}, settings, {
      sectionId: sectionId,
      imageSize: Shopify.Image.imageSize($(selectors.variantImage).attr('src'))
    });

    // Stop parsing if we don't have the product json script tag when loading
    // section in the Theme Editor
    if (!$('#ProductJson-' + sectionId).html()) {
      return;
    }

    this.productSingleObject = JSON.parse(document.getElementById('ProductJson-' + sectionId).innerHTML);

    this.init();

    // Pre-loading product images to avoid a lag when a thumbnail is clicked, or
    // when a variant is selected that has a variant image
    Shopify.Image.preload(
      this.productSingleObject.images,
      this.settings.imageSize
    );
  }

  Product.prototype = _.assignIn({}, Product.prototype, {
    init: function() {

      // @note this previously caused a js error and had a note about doesn't seem to be needed
      // @note we are now needing this for pre order system so fixed up the error ^
      this.initVariantSelectors('product-select');

      // @note product image switcher
      this.productImageSwitch();

      this.collectionBackButton();

      ajaxCart.init({
        formSelector: selectors.productForm,
        cartContainer: selectors.cartContainer,
        addToCartSelector: selectors.addToCart,
        moneyFormat: theme.moneyFormat
      });
    },

    initVariantSelectors: function(selectorId) {

      this.optionSelector = new Shopify.OptionSelectors(selectorId, {
        product: this.productSingleObject,
        // @note - onSelectChange for variant bound here (marks for system for 'made to order' / 'pre order')
        onVariantSelected: this.productVariantCallback.bind(this),
        enableHistoryState: true
      });

      // Clean up variant labels if the Shopify-defined
      // defaults are the only ones left
      this.simplifyVariantLabels(this.productSingleObject);

      // Uncomment this to add class so we can easily hide any
      // <select> with only one option
      // $optionSelectors.each(function () {
      //   var $el = $(this);
      //   var $select = $el.find('.single-option-selector');
      //
      //   if ($select[0].length < 2) {
      //     $el.addClass('selector-wrapper--single-option');
      //   }
      // });
    },

    simplifyVariantLabels: function(productObject) {
      // Hide variant dropdown if only one exists and title contains 'Default'
      if (productObject.variants.length && productObject.variants[0].title.indexOf('Default') >= 0) {
        $('.selector-wrapper').hide();
        $('.bbs-product-size-title').hide();
      }
    },

    // @note product image switcher
    productImageSwitch: function() {
      if (!selectors.productImageTiles.length) {
        return;
      }

      var self = this;

      // Just prevents default on click (because switch happens on mouse enter)
      selectors.productImageTiles.on('click', function(evt) {
        evt.preventDefault();
      });

      // Switch the main image with one of the thumbnails on mouse-enter a thumbnail
      // Note: this does not change the variant selected, just the image
      selectors.productImageTiles.on('mouseenter', function(evt) {
        evt.preventDefault();
        var newImageId = $(this).attr('data-image-id');
        self.switchImage(newImageId);
      });

      // Turn off zoom when touch supported (i.e. on mobile)
      if (!Modernizr.touchevents) {
        // Adds '.zoomImg' element (the src is changed on switchImage below so that the correct image zooms)
        selectors.productMainImage.zoom({
          on: 'click',
          magnify: 1, // If u magnify to 2 it stops zooming exactly where click happened
          // Ensure "big" image is "display: none" on load (only callsback on load)
          callback: function () {
            $(this).css('display', 'none');
          }
        });
      }
    },

    // @note product image switcher
    switchImage: function(imageId) {
      var $newImage = $(
        selectors.productImages.selector + "[data-image-id='" + imageId + "']",
        this.$container
      );
      var $otherImages = $(
        selectors.productImages.selector + ":not([data-image-id='" + imageId + "'])",
        this.$container
      );

      // @note product zoom (matches with product switcher)
      $('.zoomImg').get(0).src = $newImage.find('img').get(0).src;
      $newImage.removeClass('hide');
      $otherImages.addClass('hide');
    },

    _updatePreorderProductNote: function (variant) {
      var $noteContainer = $('[data-product-note-container]');
      var $termsContainer = $('[data-preorder-info-container]');

      if (variant.inventory_policy == 'continue') {
        if ($noteContainer.hasClass('hl-preorder-note--hidden')) { $noteContainer.removeClass('hl-preorder-note--hidden'); }
        if ($termsContainer.hasClass('hl-info-container--hidden')) { $termsContainer.removeClass('hl-info-container--hidden'); }
      } else {
        // Not pre order, remove the notes
        if ( !$noteContainer.hasClass('hl-preorder-note--hidden')) { $noteContainer.addClass('hl-preorder-note--hidden'); }
        if ( !$termsContainer.hasClass('hl-info-container--hidden')) { $termsContainer.addClass('hl-info-container--hidden'); }
      }
    },

    _updatePrice: function (variant) {
      $(selectors.productPrice).html(Shopify.formatMoney(variant.price, theme.moneyFormat).replace(/((\,00)|(\.00))$/g, ''));

      if (variant.compare_at_price > variant.price) {

        // Update and show the product's compare price
        $(selectors.salePriceWrapper).removeClass('hide');
        $(selectors.productPrice).html(Shopify.formatMoney(variant.compare_at_price, theme.moneyFormat).replace(/((\,00)|(\.00))$/g, ''));
        $(selectors.salePrice).html(Shopify.formatMoney(variant.price, theme.moneyFormat).replace(/((\,00)|(\.00))$/g, ''));

        $(selectors.productPrice).addClass('on-sale');

      } else {

        // Show full price
        $(selectors.productPrice).html(Shopify.formatMoney(variant.price, theme.moneyFormat).replace(/((\,00)|(\.00))$/g, ''));
        $(selectors.salePriceWrapper).addClass('hide');

        $(selectors.productPrice).removeClass('on-sale');
      }
    },

    // @note receives the "variant" whether it's a radio button group or a select list (all done within option_selection_fork.js)
    productVariantCallback: function(variant) {
      var $pageLink = $(selectors.pageLink, this.$container);
      var addToCartString = theme.strings.addToCart;
      var $addToCartText = $(selectors.addToCartText);

      // @note - variantChange > updateAddToCartState listener method here (marks for system for 'made to order' / 'pre order')
      if (!variant) {
        console.log('no variant');
        // The variant doesn't exist, disable submit button.
        // This may be an error or notice that a specific variant is not available.
        // To only show available variants, implement linked product options:
        //   - http://docs.shopify.com/manual/configuration/store-customization/advanced-navigation/linked-product-options
        $(selectors.addToCart).addClass('disabled').prop('disabled', true);
        $addToCartText.html(theme.strings.soldOut);
        $(".hl-product-cart-button").addClass("hl-product-cart-button--soldout");
        return;
      }

      if (variant.available) {
        console.log('available, what is inventory_policy', variant.inventory_quantity);

        if (variant.inventory_policy == 'continue') {

          if ($addToCartText.hasClass('hl-intransit')) {
            console.log('in transit, add to cart');
            addToCartString = theme.strings.addToCart;
          } else {
            console.log('pre order');
            addToCartString = theme.strings.preorderAddToCart;
          }

        } else {
          console.log('add to cart');
          addToCartString = theme.strings.addToCart;
        }
        // Available, enable the submit button, change text, show quantity elements
        $(selectors.addToCart).removeClass('disabled').prop('disabled', false);
        $addToCartText.html(addToCartString);
        $(".hl-product-cart-button").removeClass("hl-product-cart-button--soldout");

      } else {
        console.log('sold out');
        // Sold out, disable the submit button, change text, hide quantity elements
        $(selectors.addToCart).addClass('disabled').prop('disabled', true);
        $addToCartText.html(theme.strings.soldOut);
        $(".hl-product-cart-button").addClass("hl-product-cart-button--soldout");
      }

      // @note - variantImageChange / updateImages / updateProductImages methods (marks for product flow for system for 'made to order' / 'pre order')
      if (variant.featured_image) {
        var imageId = variant.featured_image.id;
        var $newImage = $(
          selectors.variantImageWrapper + "[data-image-id='" + imageId + "']",
          this.$container
        );
        var $otherImages = $(
          selectors.variantImageWrapper +
            ":not([data-image-id='" +
            imageId +
            "'])",
          this.$container
        );

        $newImage.removeClass('hide fade-in');
        $otherImages.addClass('hide');
      } else {
        $(selectors.variantImageWrapper, this.$container).removeClass(
          'fade-in'
        );
      }

      this._updatePreorderProductNote(variant);
      this._updatePrice(variant);
    },

    collectionBackButton: function() {
      if (!document.referrer || !$(selectors.productReturnLink).length || !window.history.length) {
        return;
      }

      $(selectors.productReturnLink).on('click', this.backButton);
    },

    backButton: function(evt) {
      evt.preventDefault();
      var referrerDomain = urlDomain(document.referrer);
      var shopDomain = urlDomain(window.location.href);

      // redirect to previous page if last history item is from the shops domain
      // otherwise follow link.
      if (shopDomain === referrerDomain) {
        history.back();
        return false;
      }

      function urlDomain(url) {
        var    a      = document.createElement('a');
               a.href = url;
        return a.hostname;
      }
    }
  });

  return Product;
})();


theme.RichTextSection = (function() {

  function RichTextSection() {
  }

  return RichTextSection;

})();

theme.RichTextSection.prototype = _.assignIn({}, theme.RichTextSection.prototype, {
  onBlockSelect: function(evt) {
    // TODO: scroll to block
  }
});
theme.FeaturedVideoSection = (function() {

  function FeaturedVideoSection() {
    theme.responsiveVideos();
  }

  return FeaturedVideoSection;

})();

theme.FeaturedVideoSection.prototype = _.assignIn({}, theme.FeaturedVideoSection.prototype, {

  onSelect: function() {
    theme.responsiveVideos();
  }

});

$(document).ready(function() {
  theme.init();

  var sections = new theme.Sections();

  sections.register('action-bar-section', theme.ActionBarSection);
  sections.register('slideshow-section', theme.SlideshowSection);
  sections.register('sidebar-menu-section', theme.SidebarMenuSection);
  sections.register('header-section', theme.HeaderSection);
  sections.register('collection-template-section', theme.CollectionTemplate);
  sections.register('product', theme.Product);
  sections.register('rich-text-section', theme.RichTextSection);
  sections.register('featured-video-section', theme.FeaturedVideoSection);
});


/**
 *
 *  Boundless Theme JS
 *
 *
 */
theme.init = function () {
  theme.cacheSelectors();
  theme.stringOverrides();
  theme.drawersInit();
  theme.initCart();
  theme.afterCartLoad();
  theme.rteImages();
  theme.styleTextLinks();
  theme.searchSubmit();
  theme.socialSharing();
  theme.passwordTemplate();
  theme.responsiveVideos();
  theme.mobileMenu();
  theme.sizeSelected();
  theme.closingShopPopup();
  theme.productCardImageLoadingAnimation();
};

/**
 *
 *  Cache any jQuery objects.
 *
 */
theme.cacheSelectors = function () {
  theme.cache = {
    $window: $(window),
    $html: $('html'),
    $body: $('body'),
    $indexTemplate: $('.template-index'),

    // Drawer elements
    $drawerRight: $('.drawer--right'),
    $drawerProduct: $('.drawer--product'),
    $cartContainer: $('#CartContainer'),

    // Product grid
    $productGridItem: $('.product-item'),

    // Share buttons
    $shareButtons: $('.social-sharing'),

    // Article images
    $indentedRteImages: $('.rte--indented-images'),

    // Password Page
    $loginModal: $('#LoginModal'),

    // Site Header
    $siteHeaderWrapper: $('.site-header-wrapper'),
    $siteHeader: $('.site-header-container'),
    $siteHeaderCart: $('.site-header__cart'),
    $searchInput: $('.search-bar__input'),
    $searchSubmit: $('.search-bar__submit'),

    // Hero
    $heroWrapper: $('.hero-wrapper'),
    $hero: $('#Hero'),
    $heroImages: $('.hero__image')

  }

  theme.variables = {
    isIndexTemplate: theme.cache.$indexTemplate.length,

    // Footer
    footerTop: 0,

    // track window width to solve iOS scroll triggering resize event
    windowWidth: theme.cache.$window.width()
  };
};

theme.stringOverrides = function () {
  // Override defaults in theme.strings with potential
  // template overrides
  window.productStrings = window.productStrings || {};
  $.extend(theme.strings, window.productStrings);
};

// @todo @note THIS IS WHERE LIQUID VARIABLE USED FOR MONEY FORMAT SETTING
theme.initCart = function() {
  ajaxCart.init({
    moneyFormat: theme.moneyFormat
  });
};

theme.drawersInit = function () {
  // Add required classes to HTML
  $('#PageContainer').addClass('drawer-page-content');
  $('.js-drawer-open-right').attr('aria-controls', 'CartDrawer').attr('aria-expanded', 'false');
  $('.js-drawer-open-left').attr('aria-controls', 'NavDrawer').attr('aria-expanded', 'false');
  $('.js-drawer-open-top').attr('aria-controls', 'SearchDrawer').attr('aria-expanded', 'false');

  theme.LeftDrawer = new theme.Drawers('NavDrawer', 'left');
  theme.RightDrawer = new theme.Drawers('CartDrawer', 'right', {
    'onDrawerOpen': function() {
      // Close search drawer when cart drawer opens
      if (theme.SearchDrawer && theme.SearchDrawer.drawerIsOpen) {
        theme.SearchDrawer.close();
      }
      // Also close custom search if it's open
      $(".bbs-page").removeClass("bbs-page--search-open");
      ajaxCart.load();
    }
  });
  theme.SearchDrawer = new theme.Drawers('SearchDrawer', 'top', {'onDrawerOpen': theme.searchFocus});
};

theme.searchFocus = function () {
  theme.cache.$searchInput.focus();
  // set selection range hack for iOS
  theme.cache.$searchInput[0].setSelectionRange(0, theme.cache.$searchInput[0].value.length);
};

theme.searchSubmit = function () {
  theme.cache.$searchSubmit.on('click', function(evt) {
    if (theme.cache.$searchInput.val().length == 0) {
      evt.preventDefault();
      theme.cache.$searchInput.focus();
    }
  });
};

// @todo @note HERE IS WHERE LIQUID VARIABLE IS USED
theme.socialSharing = function () {
  // Stop initializing if settings are disabled

    return;


  // General selectors
  var $buttons = theme.cache.$shareButtons;
  var $shareLinks = $buttons.find('a');
  var permalink = $buttons.attr('data-permalink');

  // Share popups
  $shareLinks.on('click', function(e) {
    e.preventDefault();
    var $el = $(this);
    var popup = $el.attr('class').replace('-','_');
    var link = $el.attr('href');
    var w = 700;
    var h = 400;

    // Set popup sizes
    switch (popup) {
      case 'share-twitter':
        h = 300;
        break;
      case 'share-fancy':
        w = 480;
        h = 720;
        break;
      case 'share-google':
        w = 500;
        break;
    }

    window.open(link, popup, 'width=' + w + ', height=' + h);
  });
}

theme.sizeCartDrawerFooter = function () {
  // Stop if our drawer doesn't have a fixed footer
  if (!theme.cache.$drawerRight.hasClass('drawer--has-fixed-footer')) {
    return;
  }

  // Elements are reprinted regularly so selectors are not cached
  var $cartFooter = $('.ajaxcart__footer').removeAttr('style');
  var $cartInner = $('.ajaxcart__inner').removeAttr('style');
  var cartFooterHeight = $cartFooter.outerHeight();

  $cartInner.css('bottom', cartFooterHeight);
  $cartFooter.css('height', cartFooterHeight);
};

theme.afterCartLoad = function () {
  theme.cache.$cartContainer.on('ajaxCart.afterCartLoad', function(evt, cart) {
    theme.RightDrawer.open();

    // set cart bubble after ajax cart update
    if (cart.item_count > 0) {
      theme.cache.$siteHeaderCart.addClass('cart-bubble--visible');
    } else {
      theme.cache.$siteHeaderCart.removeClass('cart-bubble--visible');
    }

    // Size the cart's fixed footer
    theme.sizeCartDrawerFooter();
  });

  theme.cache.$cartContainer.on('ajaxCart.updatingQty', function() {
    $('.cart__checkout').addClass('btn--ajax-disabled');
  });
};

theme.rteImages = function () {
  if (!theme.cache.$indentedRteImages.length) {
    return;
  }

  var $images = theme.cache.$indentedRteImages.find('img');
  var $rteImages = imagesLoaded($images);

  $rteImages.on('always', function (instance, image) {
    $images.each(function() {
      var $el = $(this);
      var imageWidth = $el.width();
      var attr = $el.attr('style');

      // Check if undefined or float: none
      if (!attr || attr == 'float: none;') {
        // Remove grid-breaking styles if image isn't wider than parent + 20%
        // negative margins set in CSS
        if (imageWidth < theme.cache.$indentedRteImages.width() * 1.4) {
          $el.addClass('rte__no-indent');
        }
      }
    });
  });
};

theme.styleTextLinks = function () {
  $('.rte').find('a:not(:has(img))').addClass('text-link');
}

theme.setFocus = function ($container, eventNamespace) {
  var eventName = eventNamespace ? 'focusin.' + eventNamespace : 'focusin';

  $container.attr('tabindex', '-1');

  $container.focus();

  $(document).on(eventName, function (evt) {
    if ($container[0] !== evt.target && !$container.has(evt.target).length) {
      $container.focus();

      //only set focus once
      $(document).off(eventName)
      $container.removeAttr('tabindex');
    }
  });
};

theme.passwordTemplate = function () {
  if (!theme.cache.$loginModal.length) {
    return;
  }

  // Initialize modal
  theme.PasswordModal = new window.Modals('LoginModal', 'login-modal', {
    focusOnOpen: '#Password'
  });

  // Open modal if errors exist
  if (theme.cache.$loginModal.find('.errors').length) {
    theme.PasswordModal.open();
  }
};

theme.responsiveVideos = function () {
  var $iframeVideo = $('iframe[src*="youtube.com/embed"], iframe[src*="player.vimeo"]');
  var $iframeReset = $iframeVideo.add('iframe#admin_bar_iframe');

  $iframeVideo.each(function () {
    // Add wrapper to make video responsive
    if(!$(this).parent().hasClass('video-wrapper')){
      $(this).wrap('<div class="video-wrapper"></div>');
    }
  });

  $iframeReset.each(function () {
    // Re-set the src attribute on each iframe after page load
    // for Chrome's "incorrect iFrame content on 'back'" bug.
    // https://code.google.com/p/chromium/issues/detail?id=395791
    // Need to specifically target video and admin bar
    this.src = this.src;
  });
};

theme.productCardImageLoadingAnimation = function() {
  var selectors = {
    image: '[data-image]',
    imageWithPlaceholder: '[data-image-placeholder]',
    imageWithPlaceholderWrapper: '[data-image-with-placeholder-wrapper]'
  };

  var classes = {
    loadingAnimation: 'product-item__image-container--loading',
    lazyloaded: '.lazyloaded'
  };

  $(document).on('lazyloaded', function(e) {
    var $target = $(e.target);

    if (!$target.is(selectors.image)) {
      return;
    }

    $target
      .closest(selectors.imageWithPlaceholderWrapper)
      .removeClass(classes.loadingAnimation)
      .find(selectors.imageWithPlaceholder)
      .hide();
  });

  // When the theme loads, lazysizes might load images before the "lazyloaded"
  // event listener has been attached. When this happens, the following function
  // hides the loading placeholders.
  $(selectors.image + classes.lazyloaded)
    .closest(selectors.imageWithPlaceholderWrapper)
    .removeClass(classes.loadingAnimation)
    .find(selectors.imageWithPlaceholder)
    .hide();
};

theme.mobileMenu = function () {
	var menu = $('.hl-main-content-mobile-menu');
  var menuBtn = $('.hl-mobile-menu-btn');
  menuBtn.on('click', function () {
    menu.toggleClass('hl-main-content-mobile-menu--open')
  });
};

theme.sizeSelected = function () {
	var $productDetailContainer = $('.product-detail-container')
	var $addToBag = $('.product-detail-cart-button');

	// Hide on init until size selected
	$addToBag.attr('disabled', 'disabled');
  $addToBag.addClass('product-detail-cart-button--disabled');

  // Detect when size selected and show add to bag
  $productDetailContainer.on('change', '.product-detail-select', function() {
    var $select = $(this);
    var $sizeSelected = $select.val();

    if ($sizeSelected) {
      $addToBag.removeAttr('disabled');
      $addToBag.removeClass('product-detail-cart-button--disabled');
    }
  });
}

theme.closingShopPopup = function () {
  var previouslyClosed = localStorage.getItem('hl-shop-shipping-notification-v1') === 'closed';

  // Shop popup, show if has not previously been closed with button
  if (!previouslyClosed) {
    // Show again if temporarily hidden via the click away
    $('#hl-shop-popup-container').removeClass('hl-sp-hidden');
    $('#hl-shop-popup-container').addClass('hl-sp-entrance-animation');

    // Close if user clicks elsewhere or navigates away
    // The localStorage setting means it shows again when u land on the homepage
    // until it's either submit or closed via cross button
    $('body').on('click', function () {
      $('#hl-shop-popup-container').addClass('hl-sp-hidden');
    });
    $('#hl-shop-popup-container').on('click', function (event) {
        event.stopPropagation();
    });

    // Close via cross button and don't show it again
    $('#hl-shop-popup-cross').on('click', function (event) {
      event.preventDefault();
      $('#hl-shop-popup-container').addClass('hl-sp-hidden');
      localStorage.setItem('hl-shop-shipping-notification-v1', 'closed');
    });
  }
};

/*============================================================================
  More JS
    (refer to custom.js)
==============================================================================*/
